module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "password-view"
  }, [_c('p', [_vm._v("请输入密码")]), _vm._v(" "), _c('Password', {
    attrs: {
      "length": "6",
      "value": _vm.value,
      "autofocus": ""
    },
    on: {
      "on-change": _vm.onSet
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-4388cdbc!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/passwordView.vue
// module id = 236
// module chunks = 0